import Tooltip from 'bootstrap/js/dist/tooltip'

export default function (controller) {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    Tooltip.getOrCreateInstance(el)
  })
}
